import { Button } from '@/components/ui/button';
import { SectionLabel } from '@/components/ui/section-label';
import { MessageCircle } from 'lucide-react';

// Pre-chat intro for the public dialog route. Sells the why and sets the
// ending expectation; deliberately carries no consent or persistence wording
// (that lives on the privacy policy - a pre-chat disclosure line was tried
// once and measurably nudged respondents against reviewing).
export function DialogIntro({ framing, onStart }: { framing?: string; onStart: () => void }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-linear-to-b from-background to-muted py-4 px-4">
      <div className="w-full max-w-md p-8 bg-card rounded-xl shadow-lg border space-y-5">
        <MessageCircle className="h-10 w-10 text-muted-foreground" />
        <div className="space-y-1">
          <h1 className="text-xl font-semibold">You've been invited to share your experience</h1>
          {framing && <p className="text-sm font-medium">Topic: {framing}</p>}
        </div>
        <div className="space-y-4 text-sm text-muted-foreground">
          <div className="space-y-1.5">
            <SectionLabel>What this is</SectionLabel>
            <p>
              A team is researching an early product idea with ValueGraph, and they want to
              learn from your experience. You'll chat with an AI interviewer
              about how you do this today, where it gets hard, and what would make it easier.
              There are no right answers, and you can bring up anything you think matters.
            </p>
          </div>
          <div className="space-y-1.5">
            <SectionLabel>What to expect</SectionLabel>
            <p>
              It usually takes about ten minutes. Once it has enough to work with, it will
              offer to wrap up, and you finish by pressing the Review & submit button to check
              what you share. You can keep chatting past that, or stop whenever you like.
            </p>
          </div>
        </div>
        <Button variant="brand" onClick={onStart} className="w-full">
          Start the conversation
        </Button>
      </div>
    </div>
  );
}
